import React, { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Body } from 'components/Shell/Shell'
import ComponentUnderConstruction from 'components/TemporaryPages/UnderConstruction'
import { fetchAndSetUserInfoItems } from '../../UserManager/ManageUsersActions'
import ReceiptCheckIcon from '@tecuity/sos-icons/react/receipt-check'
import ReceiptCancelIcon from '@tecuity/sos-icons/react/receipt-cancel'
import ReceiptBatchIcon from '@tecuity/sos-icons/react/receipt-batch'
import DocumentIcon from '@tecuity/sos-icons/react/document'
import CreditCardCheckIcon from '@tecuity/sos-icons/react/credit-card-check'
import { toggleSidebarCollapse, overrideSidebarResizing } from '../../../actions'
import './Reconcile.scss'
import ReconcilePaymentBatch from '../ReconcilePaymentBatch/ReconcilePaymentBatch'
import UnreconcilePaymentBatch from '../UnreconcilePaymentBatch/UnreconcilePaymentBatch'
import PostDistributions from '../PostDistributions/PostDistributions'
import PostPaymentBatch from '../PostPaymentBatch/PostPaymentBatch'

const ROUTES = [
  {
    parameter: 'reconcile',
    title: 'Reconcile Payment Batch',
    icon: 'ReceiptCheckIcon',
    componentName: 'ReconcilePaymentBatch',
    userPermissions: ['ReceiptReconcileBatch'],
  },
  {
    parameter: 'unreconcile',
    title: 'Unreconcile Payment Batch',
    icon: 'ReceiptCancelIcon',
    componentName: 'UnreconcilePaymentBatch',
    userPermissions: ['ReceiptReconcileBatch'],
  },
  {
    parameter: 'paymentBatches',
    title: 'Post Payment Batches',
    icon: 'ReceiptBatchIcon',
    componentName: 'PostPaymentBatch',
    userPermissions: ['ReceiptCloseBatch'],
  },
  {
    parameter: 'distributions',
    title: 'Post Distributions',
    icon: 'DocumentIcon',
    componentName: 'PostDistributions',
    userPermissions: ['ReceiptCloseBatch'],
  },
  // close division period not implemented yet (RECEIPT_CLOSE_OTHER_USER_BATCH)
  // { // hidden due to bug 19615
  //   parameter: 'reconcileWeb',
  //   title: 'Reconcile Web Payments',
  //   icon: 'CreditCardCheckIcon',
  //   componentName: '',
  // },
]

const Components = {
  ReconcilePaymentBatch,
  UnreconcilePaymentBatch,
  PostDistributions,
  PostPaymentBatch,
}

const Icons = {
  ReceiptCheckIcon,
  ReceiptCancelIcon,
  ReceiptBatchIcon,
  DocumentIcon,
  CreditCardCheckIcon,
}

const Reconcile = ({ selectedSubCategory, setSelectedSubCategory }) => {
  const dispatch = useDispatch()
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const [drawerShown, setDrawerShown] = React.useState(false)
  const routeProps = { setDrawerShown, drawerShown }

  useEffect(() => {
    if (selectedSubCategory === null) {
      setSelectedSubCategory('reconcile')
    }
    dispatch(fetchAndSetUserInfoItems())
    dispatch(overrideSidebarResizing(true))
    dispatch(toggleSidebarCollapse(true))
    return () => {
      dispatch(overrideSidebarResizing(false))
      dispatch(toggleSidebarCollapse(false))
    }
  }, [])

  return (
    <Body className="no-padding system-admin" showDrawer={drawerShown} style={{ display: 'flex' }}>
      <aside className="body-sidebar">
        {' '}
        {ROUTES.map((route, i) => {
          if (
            !route.userPermissions ||
            route.userPermissions.every((right) => appUserRights.includes(right))
          ) {
            const Icon = Icons[route['icon']]
            return (
              <div
                key={route.parameter || i}
                onClick={() => setSelectedSubCategory(route.parameter)}
                className={`reconcile-tab ${
                  selectedSubCategory === route.parameter ? `selected` : ``
                }`}
              >
                <span
                  title={route.title}
                  style={{ display: 'flex', flexDirection: 'row', height: '30px' }}
                >
                  {Icon && <Icon style={{ width: '30px', marginRight: '5px' }} />}
                  <span className="label" style={{ alignSelf: 'center' }}>
                    {route.title}
                  </span>
                </span>
              </div>
            )
          }
          return null
        })}
      </aside>
      <div className="accounting-details">
        {ROUTES.map((route, i) => {
          const Component = Components[`${route.componentName}`] || ComponentUnderConstruction
          return selectedSubCategory === route.parameter && <Component key={i} {...routeProps} />
        })}
      </div>
    </Body>
  )
}

export default Reconcile

